import React from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { useTranslation } from 'next-i18next';
import { logger } from '@zep/core-logger';
import { useTemporaryBooleanState } from '@/hooks';
import { CheckSmallIcon, LinkIcon } from '@/icons';
import { Button } from '@/ui_v3';
interface LinkCopySectionProps {
  url: string;
}
export const LinkCopySection = ({
  url
}: LinkCopySectionProps) => {
  const [isLinkCopied, setIsLinkCopied] = useTemporaryBooleanState(false, 2000);
  const {
    t
  } = useTranslation(['common']);
  return <div className="flex w-full min-w-0 flex-shrink-0 items-center gap-sm" data-sentry-component="LinkCopySection" data-sentry-source-file="LinkCopySection.tsx">
      <div className="flex h-[48px] min-w-0 flex-1 items-center truncate rounded-sm border border-alternative bg-alternative px-sm text-body-lg-medium">
        <p className="truncate">{url}</p>
      </div>
      <CopyToClipboard text={url} onCopy={() => {
      logger.track('share_link_copy', {
        link: url
      });
      setIsLinkCopied(true);
    }} data-sentry-element="CopyToClipboard" data-sentry-source-file="LinkCopySection.tsx">
        <Button className="shrink-0" variant="outlined" intent="alternative" leftSlot={isLinkCopied ? <CheckSmallIcon /> : <LinkIcon />} data-sentry-element="Button" data-sentry-source-file="LinkCopySection.tsx">
          <span>
            {isLinkCopied ? t('global.duplicate.complete') : t('shareModal.copyLink.button')}
          </span>
        </Button>
      </CopyToClipboard>
    </div>;
};